// Mock data for One Force Live Path to Funding Landing Page

export const stepsData = [
  {
    id: 1,
    title: "Get Qualified for $120,000 Co-Op Funding",
    shortTitle: "Qualify",
    purpose: "Confirm eligibility and understand your business goals",
    description: "This is where your journey begins. We'll learn about your business and what growth goals you're pursuing.",
    questionsAsked: [
      "What does your business do?",
      "What growth goals are you pursuing?",
      "What's currently not working?"
    ],
    link: "https://ai-horsepowered.forms.ac/get-qualified",
    ctaText: "Get Qualified",
    icon: "ClipboardCheck"
  },
  {
    id: 2,
    title: "$75 Application Fee",
    shortTitle: "Apply",
    purpose: "Confirms intent and covers review & preparation",
    description: "This small fee confirms your serious interest and covers the administrative costs of reviewing your application.",
    importantNotes: [
      "Not a funding fee",
      "No obligation to proceed",
      "Fully refundable if not approved"
    ],
    link: "https://go.oneforcelive.io/order930567-4431",
    ctaText: "Submit Application Fee",
    icon: "CreditCard"
  },
  {
    id: 3,
    title: "Book Closing Call",
    shortTitle: "Book Call",
    purpose: "Finalize funding and review platform activation",
    description: "Schedule a call with our team to finalize your funding details and walk through your platform activation.",
    link: "https://link.oneforcelive.io/widget/bookings/oneforcelocal/consultation",
    ctaText: "Book My Closing Call",
    icon: "Calendar"
  },
  {
    id: 4,
    title: "Pre-Funding Call & Confirmation",
    shortTitle: "Confirm",
    purpose: "Account Manager introduction and appointment confirmation",
    description: "Your dedicated Account Manager will reach out to confirm your appointment and ask one simple curiosity question.",
    curiosityQuestion: "What made your company interested in the $120K Co-Op Funding and AI Horse-Powered Technology?",
    icon: "Phone"
  },
  {
    id: 5,
    title: "Explore Your Resources",
    shortTitle: "Explore",
    purpose: "Check out the platform, directory, and POD",
    description: "Explore the AI Horse-Powered Systems website, discover the Best of Best Directory, and preview the POD platform.",
    closingFlow: [
      "Confirm goals",
      "Clarify challenges",
      "Why now",
      "Vision",
      "Gap review",
      "Expert assessment",
      "Commitment check",
      "Decision & next steps"
    ],
    note: "Often same-day funding available",
    icon: "FileCheck"
  },
  {
    id: 6,
    title: "Choose Your Funding Fee",
    shortTitle: "Choose Fee",
    purpose: "Select your preferred funding option",
    description: "Choose the funding fee structure that works best for your business. Both options provide the same comprehensive benefits.",
    options: [
      {
        percentage: "4%",
        subline: "Funding Fee Upfront",
        link: "https://link.oneforcelive.io/payment-link/690d0418ac56feeb9ffab328"
      },
      {
        percentage: "5%",
        subline: "Easy Payment Plan Option",
        link: "https://link.oneforcelive.io/payment-link/690d056fe5e4937e9c21a84e"
      }
    ],
    ctaText: "Select My Funding Option",
    icon: "Percent"
  },
  {
    id: 7,
    title: "View Pricing Details",
    shortTitle: "Pricing",
    purpose: "View pricing and pick your plan",
    description: "Your $120K Funding is active! View the complete pricing breakdown and select your plan.",
    whatHappens: [
      "Funding applied to your account",
      "Platform activated within 24 hours",
      "Login credentials emailed to you"
    ],
    icon: "Zap"
  },
  {
    id: 8,
    title: "Onboarding Call Scheduled?",
    shortTitle: "Onboard",
    purpose: "Your account rep will schedule your onboarding",
    description: "Your account representative will reach out to schedule your onboarding call. Let us know if it's been scheduled.",
    icon: "Users"
  },
  {
    id: 9,
    title: "Login Information",
    shortTitle: "Login",
    purpose: "Your login details are on the way",
    description: "Login credentials will be sent to your email. Visit aihpower.com and go to the 'Access' menu to find your platform login links.",
    features: [
      "CRM & Pipeline Management",
      "Marketing Automation",
      "Reporting & Analytics",
      "Virtual Teams Access"
    ],
    icon: "LayoutDashboard"
  },
  {
    id: 10,
    title: "Accept Your Invites",
    shortTitle: "Accept Invites",
    purpose: "Accept platform invites to get started",
    description: "During or before your onboarding call, accept all platform invites so you can start making orders, creating tasks, and collaborating with your team.",
    benefits: [
      "Making orders",
      "Creating tasks",
      "Collaborating with your team",
      "Full platform access"
    ],
    icon: "Send"
  }
];

export const faqData = [
  {
    question: "What is the AI Horse-Powered POD?",
    answer: "The AI Horse-Powered POD is your business service hub — a projects-on-demand system that helps you plan, execute, and grow faster using AI tools, virtual teams, and proven strategies. It bundles powerful execution with AI-driven support, automation, publishing, and performance tools into one connected platform."
  },
  {
    question: "How does the POD work?",
    answer: "Once you place an order through the POD, our team breaks down your request, scopes the work, and prepares a tailored proposal. You approve it, and our 40+ DFY (Done-For-You) departments, DWY sessions, and AI tools begin executing. The more you use, the more value you unlock from your Co-Op Funds and platform features."
  },
  {
    question: "What are Co-Op Funds?",
    answer: "Co-Op Funds are business growth credits given to you when you join the platform. They're used to pay for DFY services, AI tools, automation builds, publishing support, CRM enhancements, and more — helping you grow with less out-of-pocket cost. You can apply them directly toward the work you need executed by our POD teams."
  },
  {
    question: "What services are included in the POD?",
    answer: "Your POD gives you access to: 40+ DFY departments covering marketing, automation, design, analytics, media, and more; AI tools for content creation, ads, automation, copywriting, and visuals; Support workflows and AI Concierge support; CRM + BDC-X service center for lead management and automation; Publishing systems, Best of Best Directory placement, and lead generation frameworks. This means you get 'results-oriented execution,' not just software tools."
  },
  {
    question: "What is the AI Concierge?",
    answer: "The AI Concierge is an intelligent assistant trained on your knowledge base, dashboard features, and POD processes. It can help you navigate the platform, explain features, place orders, answer questions about services, and guide you through next best steps. Think of it as a virtual team member ready to help anytime."
  },
  {
    question: "Can I use my Co-Op Funds for all services?",
    answer: "Co-Op Funds cover most execution services and platform features such as DFY team work, AI tools, automations, and publishing support. Some third-party spend (like ad spend to Meta, Google, postcard printing + postage, or lead lists) may be billed at cost with a standard agency fee applied where applicable."
  },
  {
    question: "How do I place an order with the POD?",
    answer: "It's simple: Go to New Order in your dashboard, choose the service or department you need, fill in the guided intake form (AI assistant helps), submit your request, receive a tailored proposal, and approve to start execution. Everything is tracked in your Orders page with real-time status updates."
  },
  {
    question: "How do the AI Tools fit into my business?",
    answer: "AI Tools unlock capabilities like content generation (copy, visuals, scripts), AI-assisted advertising, workflow automation, creative assets, and voice and audio creation. Use them directly yourself (DIY) or as part of a DFY or DWY order. They're designed to speed up execution without needing outside hires."
  },
  {
    question: "What is the Best of Best Directory & Publishing?",
    answer: "The Best of Best Directory is a curated marketplace where qualified businesses are featured for enhanced visibility. It's a publishing and exposure system that boosts discovery, credibility, and lead generation across platforms. Unlike generic directories, we limit listings to one per category per 100K population — ensuring you stand out, not get lost in the crowd."
  },
  {
    question: "Is training or support included?",
    answer: "Yes. You have access to onboarding guides, knowledge base + searchable help, AI support & concierge, DWY live sessions, and team messaging and help tickets. Assistance is part of the platform, not an extra add-on."
  },
  {
    question: "How does billing work with Co-Op Funds?",
    answer: "Your billing dashboard shows Co-Op Funds available, services ordered, service fees (small percentage you pay), any third-party costs, and payment history. Co-Op is applied first, and you only pay what remains (usually service fees and pass-through costs)."
  },
  {
    question: "Do I have to move forward after applying?",
    answer: "Absolutely not. The application is simply to confirm eligibility and understand your goals. You're never obligated to proceed, and you can take all the time you need to make the right decision for your business."
  },
  {
    question: "Is this high pressure?",
    answer: "Not at all. Our process is designed to be the opposite of high pressure. We believe in guiding, not pitching. Every step exists to create clarity, and you'll never be pushed into a decision you're not comfortable with."
  },
  {
    question: "Can I think about it after the call?",
    answer: "Of course. We can provide you with a summary of everything discussed, and you can take whatever time you need. Many business owners appreciate having time to review the information with partners or advisors."
  },
  {
    question: "What are the 40 virtual departments?",
    answer: "The 40 departments cover everything your business needs: Marketing, Sales, Customer Service, Web Development, Graphic Design, Video Production, Social Media Management, SEO, Paid Ads, Email Marketing, CRM Management, Reputation Management, Content Writing, and much more. Each department is staffed by trained specialists and AI tools."
  },
  {
    question: "What is DFY, DWY, and DIY?",
    answer: "DFY (Done-For-You) means our team handles everything. DWY (Done-With-You) means you collaborate with our experts. DIY (Do-It-Yourself) means you have 3000+ AI tools at your fingertips to execute yourself. You can mix and match depending on the project."
  },
  {
    question: "What is the Cinematic Ad System?",
    answer: "The Cinematic Ad System creates Hollywood-quality video ads for your business using AI. These aren't basic slideshows — they're professional, attention-grabbing ads designed to convert viewers into customers across social media and paid platforms."
  },
  {
    question: "How quickly can I get started?",
    answer: "Your platform is activated within 24 hours of approval. From there, you can immediately start submitting orders to your virtual team, using the AI tools, or having our team execute projects for you."
  },
  {
    question: "What if I need to talk to a partner or board?",
    answer: "That's completely understandable and professional. We can schedule a follow-up call that includes your partner or board members, or provide materials they can review independently."
  },
  {
    question: "What happens if I don't decide right away?",
    answer: "Nothing negative happens. Your application remains active, and you can proceed whenever you're ready. We're here to support your timeline, not impose ours."
  },
  {
    question: "Do I need technical skills to use the POD?",
    answer: "Not at all. The POD is designed for business owners, not tech experts. You can submit requests in plain English, and our team (or AI) handles the technical execution. If you want to learn the tools yourself, we provide full training."
  },
  {
    question: "What kind of results can I expect?",
    answer: "Results vary by business, but our clients typically see 2-3x revenue growth within 12 months. The combination of AI tools, virtual teams, and strategic marketing creates a growth engine that works around the clock."
  },
  {
    question: "Is there ongoing support after activation?",
    answer: "Yes. You'll have continuous access to your Account Manager, the 40-department virtual team, Athena AI assistant, technical support, and our full resource library. You're never alone in this journey."
  },
  {
    question: "Can I upgrade or cancel at any time?",
    answer: "Yes. Your plan is flexible. Upgrade or change your level of engagement based on your business needs. Co-Op Funds and execution capacity grow as you use the system and qualify for future funding tiers."
  }
];

export const botResponses = {
  greeting: "Hello! I'm the One Force Live Funding Guide. I'm here to help you understand the path to funding and answer any questions you might have. How can I assist you today?",
  objections: {
    "think about it": "That's completely fair. Most business owners ask that at this stage. Would it help if I walked you through what happens next so you can decide calmly? There's absolutely no pressure to move forward today.",
    "expensive": "I understand cost is always a consideration. Let me clarify — the $75 application fee is fully refundable if you don't qualify, and the funding fee is percentage-based to scale with your specific situation. Would you like me to explain how the $120K Co-Op Funding offsets your costs?",
    "burned before": "I'm sorry to hear you've had negative experiences. That's exactly why we've designed this process to be transparent and pressure-free. You can review everything before committing, and you're never obligated to proceed. What would help you feel more confident?",
    "talk to someone": "Of course! You can absolutely discuss this with a partner, advisor, or board. We can provide a summary of everything for you to share, or schedule a call that includes them. What would work best for you?",
    "contracts": "Great question. Our agreements are straightforward and designed for clarity, not complexity. You'll have full opportunity to review everything before making any commitments. Would you like me to explain what's included?",
    "doesn't work": "That's a valid concern. Our platform is backed by proven results from businesses across multiple industries. We also provide ongoing support and a dedicated account manager to ensure you succeed. What specific outcomes are you hoping for?",
    "legit": "Absolutely understandable to verify. One Force Live is a legitimate company that has helped hundreds of businesses access funding and growth tools. You can review our website, testimonials, and speak with our team before making any decisions.",
    "funding fee": "The funding fee (4% or 5%) is what makes the $120K Co-Op program possible. It covers the administrative and operational costs of the entire system — including your AI platform, virtual team access, and ongoing support. It's structured to be affordable relative to the value provided.",
    "not ready": "That's okay! There's no timeline pressure. You can go through the qualification process to understand your options, and proceed only when you feel ready. What would help you feel more prepared?",
    "do this later": "Of course. Your application doesn't expire, and you can proceed whenever timing is right for your business. Is there anything I can clarify now that might help your future decision?"
  },
  fallback: "I want to make sure I give you the best answer. Could you tell me a bit more about what you're wondering about? I'm here to help with any questions about the funding process, steps, fees, or what to expect."
};

export const heroContent = {
  headline: "The One Force Live™ Path to Funding",
  tagline: "Get Funded. Get Activated. Never Worry About Leads, Marketing, or Execution Again.",
  description: "This is where businesses unlock up to $120,000 in Business Co-Op Funds and activate the AI Horse-Powered Platform — including CRM, POD execution, AI tools, ads, and growth systems.",
  bulletIntro: "In just 3 minutes, you'll see:",
  bullets: [
    "If you qualify for Co-Op funding",
    "How your funds are applied across DFY, DWY & DIY services",
    "Exactly how you go from application → activation → growth"
  ],
  bottomText: "No pressure. No confusion. No surprises.",
  ctaText: "Your AI Funding Assistant will guide you step-by-step so you can get approved, funded, and active — fast.",
  primaryCta: "Start Step 1: Get Qualified",
  secondaryCta: "Jump to My Next Step"
};
